<template>
    <div class="symbol-groups">
        <BaseModalChipsList>
            <template #content>
                <template v-for="(cat, index) in marketCats">
                    <BaseModalChipsListItem v-if="cat.symbols.length || (cat.key === 'all' || cat.key === 'favorites')"
                        :key="index" :class="{ active: currentCat === cat.key }" @click.native="changeCat(cat.key)">
                        <template #content>
                            <div class="chips-item" :class="{ active: currentCat === cat.key }">
                                <template>
                                    <svg v-if="cat.key === 'favorites'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M7.875 8.625H13.125V7.875H7.875V8.625Z" fill="#9A9DAB" />
                                        <path d="M4.875 11.25V12H13.125V11.25H4.875Z" fill="#9A9DAB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M4.5 3.75C3.25736 3.75 2.25 4.75736 2.25 6V12.75C2.25 13.9926 3.25736 15 4.5 15H13.5C14.7426 15 15.75 13.9926 15.75 12.75V6C15.75 4.75736 14.7426 3.75 13.5 3.75H4.5ZM13.5 4.5H4.5C3.67157 4.5 3 5.17157 3 6V6.375H7.125L6.00285 8.25L7.125 10.125H3V12.75C3 13.5784 3.67157 14.25 4.5 14.25H13.5C14.3284 14.25 15 13.5784 15 12.75V6C15 5.17157 14.3284 4.5 13.5 4.5ZM3 9.375H5.80515L5.12716 8.25L5.80515 7.125H3V9.375Z"
                                            fill="#9A9DAB" />
                                    </svg>
                                    <svg v-else-if="cat.key === 'all'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18">
                                        <path
                                            d="M4.3875 3.75C3.8206 3.75 3.27692 3.97311 2.87606 4.37024C2.4752 4.76738 2.25 5.30601 2.25 5.86765V12.8824C2.25 13.444 2.4752 13.9826 2.87606 14.3798C3.27692 14.7769 3.8206 15 4.3875 15H13.6125C14.1794 15 14.7231 14.7769 15.1239 14.3798C15.5248 13.9826 15.75 13.444 15.75 12.8824V5.86765C15.75 5.30601 15.5248 4.76738 15.1239 4.37024C14.7231 3.97311 14.1794 3.75 13.6125 3.75H4.3875ZM2.9625 5.86765C2.9625 5.49322 3.11263 5.13414 3.37987 4.86938C3.64711 4.60462 4.00957 4.45588 4.3875 4.45588H13.6125C13.9904 4.45588 14.3529 4.60462 14.6201 4.86938C14.8874 5.13414 15.0375 5.49322 15.0375 5.86765V12.8824C15.0375 13.2568 14.8874 13.6159 14.6201 13.8806C14.3529 14.1454 13.9904 14.2941 13.6125 14.2941H4.3875C4.00957 14.2941 3.64711 14.1454 3.37987 13.8806C3.11263 13.6159 2.9625 13.2568 2.9625 12.8824V5.86765Z" />
                                        <path d="M4.875 8.625H13.125V7.875H4.875V8.625Z" />
                                        <path d="M4.875 11.25V12H13.125V11.25H4.875Z" />
                                    </svg>
                                    <svg v-else-if="cat.key === 'forex'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <path
                                            d="M11.2523 14.25C9.78725 14.25 8.54563 13.7416 7.52738 12.7249C6.50913 11.7081 6 10.4673 6 9.00225C6 7.53725 6.50838 6.29563 7.52513 5.27738C8.54188 4.25913 9.78275 3.75 11.2478 3.75C12.7128 3.75 13.9544 4.25838 14.9726 5.27513C15.9909 6.29188 16.5 7.53275 16.5 8.99775C16.5 10.4628 15.9916 11.7044 14.9749 12.7226C13.9581 13.7409 12.7172 14.25 11.2523 14.25ZM5.25 14.0336C4.11725 13.7318 3.20906 13.113 2.52544 12.1774C1.84181 11.2419 1.5 10.1828 1.5 9C1.5 7.81725 1.84181 6.75812 2.52544 5.82262C3.20906 4.887 4.11725 4.26825 5.25 3.96637V4.7625C4.35 5.075 3.625 5.61875 3.075 6.39375C2.525 7.16875 2.25 8.0375 2.25 9C2.25 9.9625 2.525 10.8313 3.075 11.6063C3.625 12.3813 4.35 12.925 5.25 13.2375V14.0336ZM11.25 13.5C12.5 13.5 13.5625 13.0625 14.4375 12.1875C15.3125 11.3125 15.75 10.25 15.75 9C15.75 7.75 15.3125 6.6875 14.4375 5.8125C13.5625 4.9375 12.5 4.5 11.25 4.5C10 4.5 8.9375 4.9375 8.0625 5.8125C7.1875 6.6875 6.75 7.75 6.75 9C6.75 10.25 7.1875 11.3125 8.0625 12.1875C8.9375 13.0625 10 13.5 11.25 13.5Z"
                                            fill="#9A9DAB" />
                                    </svg>
                                    <svg v-else-if="cat.key === 'stocks'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <g transform="translate(3, 1)">
                                            <path
                                                d="M1.21162 13.75C0.876 13.75 0.590125 13.632 0.354 13.396C0.118 13.1599 0 12.874 0 12.5384V4.46163C0 4.126 0.118 3.84013 0.354 3.604C0.590125 3.368 0.876 3.25 1.21162 3.25H3C3 2.41438 3.29112 1.7055 3.87337 1.12338C4.4555 0.541125 5.16437 0.25 6 0.25C6.83563 0.25 7.5445 0.541125 8.12663 1.12338C8.70887 1.7055 9 2.41438 9 3.25H10.7884C11.124 3.25 11.4099 3.368 11.646 3.604C11.882 3.84013 12 4.126 12 4.46163V12.5384C12 12.874 11.882 13.1599 11.646 13.396C11.4099 13.632 11.124 13.75 10.7884 13.75H1.21162ZM1.21162 13H10.7884C10.9039 13 11.0097 12.9519 11.1058 12.8558C11.2019 12.7597 11.25 12.6539 11.25 12.5384V4.46163C11.25 4.34613 11.2019 4.24031 11.1058 4.14419C11.0097 4.04806 10.9039 4 10.7884 4H1.21162C1.09612 4 0.990313 4.04806 0.894188 4.14419C0.798063 4.24031 0.75 4.34613 0.75 4.46163V12.5384C0.75 12.6539 0.798063 12.7597 0.894188 12.8558C0.990313 12.9519 1.09612 13 1.21162 13ZM3.75 3.25H8.25C8.25 2.625 8.03125 2.09375 7.59375 1.65625C7.15625 1.21875 6.625 1 6 1C5.375 1 4.84375 1.21875 4.40625 1.65625C3.96875 2.09375 3.75 2.625 3.75 3.25Z"
                                                fill="#9A9DAB" />
                                        </g>
                                    </svg>
                                    <svg v-else-if="cat.key === 'indices'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <g transform="translate(3, 3)">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M2.5 0.482143C2.5 0.215863 2.28414 0 2.01786 0C1.75158 0 1.53571 0.215863 1.53571 0.482143V11.0357H0.732143C0.465863 11.0357 0.25 11.2516 0.25 11.5179C0.25 11.7841 0.465863 12 0.732142 12H3.30357C3.56985 12 3.78571 11.7841 3.78571 11.5179C3.78571 11.2516 3.56985 11.0357 3.30357 11.0357H2.5V8.78571H13.4621C13.7383 8.78571 13.9621 8.56186 13.9621 8.28571V1.78571C13.9621 1.50957 13.7383 1.28571 13.4621 1.28571H2.5V0.482143ZM2.5 4.76786V7.82143H6.67857H7.64286H12.2843H13.0536V2.24357H12.2843H7.64286H6.67857H2.5V3.80357V4.76786Z"
                                                fill="#9A9DAB" />
                                        </g>
                                    </svg>
                                    <svg v-else-if="cat.key === 'crypto'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M13.7606 14.1992C14.213 14.1081 14.6431 13.9183 15.0242 13.6416C15.4054 13.3649 15.7294 13.0072 15.9762 12.5907C16.223 12.1741 16.3874 11.7077 16.459 11.2202C16.5307 10.7327 16.5082 10.2347 16.3928 9.75692C16.2775 9.27918 16.0718 8.83195 15.7886 8.44297C15.5053 8.054 15.1505 7.73159 14.7462 7.49573C14.3419 7.25988 13.8967 7.11563 13.4382 7.07193C12.9797 7.02822 12.5178 7.086 12.081 7.24167C11.9038 6.46883 11.4928 5.7807 10.9122 5.28477C10.3316 4.78884 9.6142 4.51304 8.87198 4.50045C8.12976 4.48787 7.40456 4.73921 6.80966 5.21521C6.21476 5.69121 5.78366 6.36506 5.58372 7.1315C5.12272 7.02235 4.64544 7.0186 4.183 7.12051C3.72056 7.22241 3.28335 7.42767 2.89987 7.7229C2.5164 8.01814 2.19527 8.39671 1.95743 8.83395C1.7196 9.27119 1.57039 9.75726 1.51954 10.2605C1.46869 10.7637 1.51735 11.2727 1.66233 11.7544C1.80732 12.2361 2.04538 12.6797 2.36098 13.0561C2.67659 13.4325 3.06266 13.7334 3.49402 13.9391C3.92537 14.1448 4.39233 14.2508 4.86443 14.25H5.06599L13.7606 14.1992ZM11.5198 8.34334L11.3143 7.44506C11.1786 6.85437 10.8643 6.32848 10.4204 5.94947C9.97658 5.57046 9.42819 5.35967 8.86084 5.34999C8.2935 5.34031 7.73913 5.53229 7.28427 5.89597C6.82941 6.25965 6.49965 6.77455 6.34647 7.36031L6.14492 8.13148L5.42168 7.96199C5.06865 7.87645 4.70274 7.87185 4.34793 7.9485C3.99312 8.02515 3.65743 8.18132 3.36285 8.40678C3.06826 8.63223 2.82144 8.92188 2.63856 9.25674C2.45567 9.59161 2.34085 9.96412 2.30162 10.3499C2.26239 10.7356 2.29963 11.1259 2.41091 11.4952C2.52219 11.8644 2.70499 12.2043 2.94733 12.4925C3.18968 12.7807 3.48609 13.0108 3.81715 13.1676C4.14821 13.3245 4.50645 13.4045 4.86838 13.4026H5.06599L13.7606 13.3305C14.323 13.1875 14.8239 12.8454 15.1825 12.3595C15.541 11.8736 15.7363 11.2722 15.7367 10.6526C15.7375 10.2143 15.6405 9.78203 15.4539 9.392C15.2673 9.00198 14.9963 8.66544 14.6638 8.41044C14.3312 8.15545 13.9466 7.9894 13.542 7.92614C13.1374 7.86287 12.7245 7.90422 12.3379 8.04674L11.5198 8.34334Z"
                                            fill="#9A9DAB" />
                                    </svg>
                                    <svg v-else-if="cat.key === 'commodities'" xmlns="http://www.w3.org/2000/svg"
                                        width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path
                                            d="M4.56919 14.1729C4.07406 13.6729 3.68875 13.1012 3.41325 12.4578C3.13775 11.8143 3 11.149 3 10.4619C3 9.77051 3.13319 9.08133 3.39956 8.39433C3.66594 7.70733 4.09331 7.06958 4.68169 6.48108C5.15769 6.0052 5.76081 5.62783 6.49106 5.34895C7.22144 5.07008 8.01519 4.86645 8.87231 4.73808C9.72956 4.6097 10.6181 4.53876 11.5378 4.52526C12.4574 4.51189 13.3433 4.53401 14.1953 4.59164C14.2568 5.41664 14.2808 6.28683 14.2673 7.2022C14.2539 8.11758 14.1796 9.00533 14.0445 9.86545C13.9094 10.7256 13.7031 11.5236 13.4257 12.2596C13.1484 12.9958 12.7751 13.5985 12.3058 14.0677C11.7298 14.6532 11.1084 15.0799 10.4415 15.3478C9.77475 15.6155 9.1055 15.7494 8.43375 15.7494C7.7295 15.7494 7.03313 15.6116 6.34463 15.3361C5.65625 15.0606 5.06444 14.6729 4.56919 14.1729ZM5.83275 14.2263C6.224 14.487 6.64875 14.681 7.107 14.8083C7.56513 14.9357 8.00863 14.9994 8.4375 14.9994C9.019 14.9994 9.59419 14.8861 10.1631 14.6596C10.7319 14.4333 11.2678 14.059 11.7707 13.5369C11.9939 13.3119 12.2203 12.9963 12.4496 12.59C12.679 12.1838 12.8774 11.6525 13.0448 10.9963C13.2121 10.34 13.3393 9.54626 13.4261 8.61501C13.5129 7.68376 13.5346 6.57439 13.4914 5.28689C12.8789 5.26189 12.1834 5.25733 11.4051 5.2732C10.6267 5.28908 9.84906 5.35564 9.07219 5.47289C8.29519 5.59026 7.56537 5.76914 6.88275 6.00951C6.2 6.24989 5.65431 6.57439 5.24569 6.98301C4.69281 7.53589 4.30531 8.10895 4.08319 8.7022C3.86106 9.29558 3.75 9.84851 3.75 10.361C3.75 11.0408 3.88581 11.6756 4.15744 12.2655C4.42906 12.8553 4.75769 13.3157 5.14331 13.6466C5.45669 12.762 5.94131 11.9131 6.59719 11.1001C7.25294 10.2871 8.17025 9.5292 9.34913 8.82633C8.4875 9.57533 7.76319 10.3722 7.17619 11.217C6.58919 12.0617 6.14137 13.0648 5.83275 14.2263Z"
                                            fill="#9A9DAB" />
                                    </svg>
                                    <svg v-else-if="cat.key === 'metals'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <path
                                            d="M9 15C7.24713 15 5.80888 14.7767 4.68525 14.3301C3.56175 13.8834 3 13.3087 3 12.6058V5.25C3 4.62688 3.58488 4.09613 4.75463 3.65775C5.92425 3.21925 7.33938 3 9 3C10.6606 3 12.0758 3.21925 13.2454 3.65775C14.4151 4.09613 15 4.62688 15 5.25V12.6058C15 13.3087 14.4383 13.8834 13.3148 14.3301C12.1911 14.7767 10.7529 15 9 15ZM9 6.66788C10.074 6.66788 11.1567 6.51806 12.2481 6.21844C13.3394 5.91894 13.9923 5.59275 14.2067 5.23988C14.0019 4.86775 13.3594 4.52644 12.279 4.21594C11.1988 3.90531 10.1058 3.75 9 3.75C7.91063 3.75 6.81906 3.89975 5.72531 4.19925C4.63156 4.49875 3.97794 4.82638 3.76444 5.18213C3.96831 5.55713 4.61231 5.8985 5.69644 6.20625C6.78056 6.514 7.88175 6.66788 9 6.66788ZM9 10.4423C9.51538 10.4423 10.0216 10.4173 10.5188 10.3673C11.0159 10.3173 11.4911 10.243 11.9445 10.1445C12.3979 10.0459 12.819 9.923 13.2079 9.77588C13.5969 9.62888 13.9443 9.46306 14.25 9.27844V6.20625C13.9443 6.39088 13.5969 6.55675 13.2079 6.70387C12.819 6.851 12.3979 6.97381 11.9445 7.07231C11.4911 7.17094 11.0159 7.24525 10.5188 7.29525C10.0216 7.34525 9.51538 7.37025 9 7.37025C8.46538 7.37025 7.94569 7.34281 7.44094 7.28794C6.93606 7.23319 6.45937 7.1565 6.01087 7.05787C5.56225 6.95937 5.14663 6.83894 4.764 6.69656C4.38125 6.55431 4.04325 6.39088 3.75 6.20625V9.27844C4.04325 9.46306 4.38125 9.6265 4.764 9.76875C5.14663 9.911 5.56225 10.0314 6.01087 10.1301C6.45937 10.2286 6.93606 10.3053 7.44094 10.3601C7.94569 10.4149 8.46538 10.4423 9 10.4423ZM9 14.25C9.64225 14.25 10.2531 14.2134 10.8324 14.1403C11.4118 14.0673 11.9323 13.9638 12.3938 13.8296C12.8553 13.6955 13.2476 13.5354 13.5707 13.3493C13.8938 13.1633 14.1203 12.9621 14.25 12.7457V10.0284C13.9443 10.2131 13.5969 10.3789 13.2079 10.5259C12.819 10.673 12.3979 10.7959 11.9445 10.8945C11.4911 10.993 11.0159 11.0673 10.5188 11.1173C10.0216 11.1673 9.51538 11.1923 9 11.1923C8.46538 11.1923 7.94569 11.1649 7.44094 11.1101C6.93606 11.0553 6.45937 10.9786 6.01087 10.8801C5.56225 10.7814 5.14663 10.661 4.764 10.5188C4.38125 10.3765 4.04325 10.2131 3.75 10.0284V12.75C3.87975 12.976 4.1055 13.1789 4.42725 13.3586C4.74888 13.5385 5.14044 13.6955 5.60194 13.8296C6.06344 13.9638 6.58456 14.0673 7.16531 14.1403C7.74619 14.2134 8.35775 14.25 9 14.25Z"
                                            fill="#9A9DAB" />
                                    </svg>
                                    <svg v-else-if="cat.key === 'turkish'" xmlns="http://www.w3.org/2000/svg" width="18"
                                        height="18" viewBox="0 0 18 18" fill="none">
                                        <path
                                            d="M9 15C7.24713 15 5.80888 14.7767 4.68525 14.3301C3.56175 13.8834 3 13.3087 3 12.6058V5.25C3 4.62688 3.58488 4.09613 4.75463 3.65775C5.92425 3.21925 7.33938 3 9 3C10.6606 3 12.0758 3.21925 13.2454 3.65775C14.4151 4.09613 15 4.62688 15 5.25V12.6058C15 13.3087 14.4383 13.8834 13.3148 14.3301C12.1911 14.7767 10.7529 15 9 15ZM9 6.66788C10.074 6.66788 11.1567 6.51806 12.2481 6.21844C13.3394 5.91894 13.9923 5.59275 14.2067 5.23988C14.0019 4.86775 13.3594 4.52644 12.279 4.21594C11.1988 3.90531 10.1058 3.75 9 3.75C7.91063 3.75 6.81906 3.89975 5.72531 4.19925C4.63156 4.49875 3.97794 4.82638 3.76444 5.18213C3.96831 5.55713 4.61231 5.8985 5.69644 6.20625C6.78056 6.514 7.88175 6.66788 9 6.66788ZM9 10.4423C9.51538 10.4423 10.0216 10.4173 10.5188 10.3673C11.0159 10.3173 11.4911 10.243 11.9445 10.1445C12.3979 10.0459 12.819 9.923 13.2079 9.77588C13.5969 9.62888 13.9443 9.46306 14.25 9.27844V6.20625C13.9443 6.39088 13.5969 6.55675 13.2079 6.70387C12.819 6.851 12.3979 6.97381 11.9445 7.07231C11.4911 7.17094 11.0159 7.24525 10.5188 7.29525C10.0216 7.34525 9.51538 7.37025 9 7.37025C8.46538 7.37025 7.94569 7.34281 7.44094 7.28794C6.93606 7.23319 6.45937 7.1565 6.01087 7.05787C5.56225 6.95937 5.14663 6.83894 4.764 6.69656C4.38125 6.55431 4.04325 6.39088 3.75 6.20625V9.27844C4.04325 9.46306 4.38125 9.6265 4.764 9.76875C5.14663 9.911 5.56225 10.0314 6.01087 10.1301C6.45937 10.2286 6.93606 10.3053 7.44094 10.3601C7.94569 10.4149 8.46538 10.4423 9 10.4423ZM9 14.25C9.64225 14.25 10.2531 14.2134 10.8324 14.1403C11.4118 14.0673 11.9323 13.9638 12.3938 13.8296C12.8553 13.6955 13.2476 13.5354 13.5707 13.3493C13.8938 13.1633 14.1203 12.9621 14.25 12.7457V10.0284C13.9443 10.2131 13.5969 10.3789 13.2079 10.5259C12.819 10.673 12.3979 10.7959 11.9445 10.8945C11.4911 10.993 11.0159 11.0673 10.5188 11.1173C10.0216 11.1673 9.51538 11.1923 9 11.1923C8.46538 11.1923 7.94569 11.1649 7.44094 11.1101C6.93606 11.0553 6.45937 10.9786 6.01087 10.8801C5.56225 10.7814 5.14663 10.661 4.764 10.5188C4.38125 10.3765 4.04325 10.2131 3.75 10.0284V12.75C3.87975 12.976 4.1055 13.1789 4.42725 13.3586C4.74888 13.5385 5.14044 13.6955 5.60194 13.8296C6.06344 13.9638 6.58456 14.0673 7.16531 14.1403C7.74619 14.2134 8.35775 14.25 9 14.25Z"
                                            fill="#9A9DAB" />
                                    </svg>
                                </template>
                                <span class="chips-name">{{ cat.alias || cat.name }}</span>
                                <span class="chips-cnt">{{ cat.cnt }}</span>
                            </div>
                        </template>
                    </BaseModalChipsListItem>
                </template>
            </template>
        </BaseModalChipsList>

        <BaseSearch v-model="search" :placeholder="tokens.widgetMarketWatch.search"/>

        <div class="content scroll">
            <div class="col">
                <MarketItem
                    v-for="symbol in filteredSymbols"
                    :key="symbol.symbol"
                    :symbol="symbol"
                    :class="{
                        active: charts[chartActive] && charts[chartActive].symbol === symbol.symbol
                      }"
                    v-ripple
                    @change="changeSymbol"
                    @add="addChart"
                    @info="showAssetsInfoModal"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {
    MODAL,
    MODAL_MENU,
    SYMBOL_ACTIVE_UPDATE,
    SYMBOL_SHOW,
    MODAL_ASSETS_INFO
} from '@/store/mutations.type'
import { isMobile } from '@/common/helpers'
import { mapGetters } from 'vuex'
import { MARKET_WATCH_DEFAULT_CAT, BRAND } from "@/common/config"
import BaseSearch from "@/new-design/shared/ui/Inputs/BaseSearch.vue"
import MarketItem from "@/new-design/entities/MarketWatch/ui/MarketItem.vue"
import BaseModalChipsListItem from "@/new-design/shared/ui/chips/BaseModalChipsListItem.vue"
import BaseModalChipsList from "@/new-design/shared/ui/chips/BaseModalChipsList.vue"

export default {
    name: 'SymbolsGroup',
    components: {BaseModalChipsList, BaseModalChipsListItem, MarketItem, BaseSearch},
    data() {
        return {
            search: '',
            collapsed: {
                forex: MARKET_WATCH_DEFAULT_CAT === 'forex' ? false : true,
                stocks: MARKET_WATCH_DEFAULT_CAT === 'stocks' ? false : true,
                indices: MARKET_WATCH_DEFAULT_CAT === 'indices' ? false : true,
                commodities: MARKET_WATCH_DEFAULT_CAT === 'commodities' ? false : true,
                crypto: MARKET_WATCH_DEFAULT_CAT === 'crypto' ? false : true,
                metals: MARKET_WATCH_DEFAULT_CAT === 'metals' ? false : true,
                turkish: MARKET_WATCH_DEFAULT_CAT === 'turkish' ? false : true,
                nft: MARKET_WATCH_DEFAULT_CAT === 'nft' ? false : true
            },
            brand: BRAND,
            time: Date.now(),
            currentCat: 'all',
        }
    },
    methods: {
        changeCat(cat) {
            if (this.currentCat === cat) {
                return
            }

            this.currentCat = cat.toLowerCase()
        },
        hideModal(widget) {
            let n = JSON.parse(JSON.stringify(this.modalMenu))

            n[widget] = !n[widget]

            this.$store.commit(MODAL_MENU, n)

            let hideMenuModal = true

            for (let i in n) {
                if (n[i]) {
                    hideMenuModal = false
                    break
                }
            }

            if (hideMenuModal) {
                this.$store.commit(MODAL, {
                    menu: false,
                    sideMenu: !isMobile()
                })
            }
        },
        showMenuModal(item) {
            this.$store.commit(MODAL, {
                menu: true
            })

            let m = {
                orders: false,
                history: false,
                market: false,
                calendar: false,
                news: false
            }

            m[item] = true

            this.$store.commit(MODAL_MENU, m)
        },
        showAssetsInfoModal(symbol) {
            this.$store.commit(MODAL, {
                symbols: false
            })

            this.showMenuModal('market')
            this.$store.commit(MODAL_ASSETS_INFO, {
                alias: symbol.alias,
                symbol: symbol.symbol,
                chartActive: this.chartActive
            })
            this.$store.commit(MODAL, {
                assetsInfo: true,
            })
        },
        changeSymbol(symbol) {
            if (isMobile() && !this.modals.symbol) {
                this.$store.commit(MODAL, {
                    menu: false,
                    sideMenu: !isMobile()
                })
            }

            if (this.modals.symbols || !Object.keys(this.charts).length) {
                this.addChart(symbol)
            } else {
                this.$store.commit(SYMBOL_ACTIVE_UPDATE, {
                    alias: symbol.alias,
                    symbol: symbol.symbol,
                    id: this.chartActive
                })
            }

        },
        addChart(symbol) {
            if (this.modals.symbols) {
                this.$store.commit(MODAL, {
                    symbols: false,
                })
            }

            this.$store.commit(SYMBOL_SHOW, {
                alias: symbol.alias,
                symbol: symbol.symbol,
                frame: 1
            })
        },
        shift(data, time) {
            let shifted = 0
            let tempArray = [].concat(data[0], data[1], data[2], data[3], data[4], data[5], data[6])
            let tempShifted = []
            if (time > 0) {

                for (let i = 0; i < time; i++) {
                    shifted = tempArray.pop()
                    tempShifted[i] = shifted
                }

                for (let i = 0; i < tempShifted.length; i++) {
                    tempArray.unshift(tempShifted[i])
                }
            } else if (time < 0) {
                time = Math.abs(time)
                for (let i = 0; i < time; i++) {
                    shifted = tempArray.shift()
                    tempShifted[i] = shifted
                }

                for (let i = 0; i < tempShifted.length; i++) {
                    tempArray.push(tempShifted[i])
                }
            }

            const chunkArray = (arr, cnt) => arr.reduce((prev, cur, i, a) => !(i % cnt) ? prev.concat([a.slice(i, i + cnt)]) : prev, [])

            let newArray = []
            newArray = chunkArray(tempArray, 24)
            return newArray
        },
        generateMarketCats() {
            let cats = {
                favorites: {
                    name: this.tokens.markets.favorites,
                    key: 'favorites',
                    ico: 'icon_bookmark',
                    cnt: 0,
                    symbols: []
                },
                all: {
                    name: this.tokens.markets.all,
                    cnt: 0,
                    key: 'all',
                    symbols: []
                },
                forex: {
                    name: this.tokens.markets.forex,
                    ico: 'euro_symbol',
                    key: 'forex',
                    cnt: 0,
                    symbols: [],
                },
                stocks: {
                    name: this.tokens.markets.stocks,
                    ico: 'account_balance',
                    key: 'stocks',
                    cnt: 0,
                    symbols: [],
                },
                indices: {
                    name: this.tokens.markets.indices,
                    ico: 'pie_chart',
                    key: 'indices',
                    cnt: 0,
                    symbols: [],
                },
                crypto: {
                    name: this.tokens.markets.crypto,
                    ico: 'cloud',
                    key: 'crypto',
                    cnt: 0,
                    symbols: [],
                },
                commodities: {
                    name: this.tokens.markets.commodities,
                    ico: 'local_fire_department',
                    key: 'commodities',
                    cnt: 0,
                    symbols: [],
                },
                metals: {
                    name: this.tokens.markets.metals,
                    ico: 'view_stream',
                    key: 'metals',
                    cnt: 0,
                    symbols: [],
                },
                turkish: {
                    name: 'Borsa Istanbul',
                    ico: 'view_stream',
                    key: 'turkish',
                    cnt: 0,
                    symbols: [],
                },
                nft: {
                    name: this.tokens.markets.nft,
                    ico: 'collections',
                    key: 'nft',
                    cnt: 0,
                    symbols: []
                }
            }

            for (let n in this.symbols) {
                let s = this.symbols[n]

                if (!s.visible) {
                    continue
                }

                if (!cats[s.market]) {
                    continue
                }

                cats.all.symbols.push(s)
                cats.all.cnt++

                cats[s.market].symbols.push(s)
                cats[s.market].cnt++

                if (this.symbolsFavorite.some(fav => fav.symbol === s.symbol)) {
                    cats.favorites.symbols.push(s)
                    cats.favorites.cnt++
                }
            }

            return Object.values(cats)
        },
    },
    computed: {
        ...mapGetters(['modals', 'tokens', 'symbols', 'sessions', 'sessionsState', 'symbolGroups', 'chartActive', 'charts', 'modalMenu', 'staticBase', 'symbolsFavorite']),
        marketCats() {
            return this.generateMarketCats()
        },
        filteredSymbols() {
            const cat = this.marketCats.find(c => c.key.toLowerCase() === this.currentCat)
            if (!cat) return []

            if (!this.search) {
                return cat.symbols
            }

            const searchTerm = this.search.toLowerCase()
            return cat.symbols.filter(symbol =>
                symbol.symbol.toLowerCase().includes(searchTerm) ||
                symbol.alias.toLowerCase().includes(searchTerm)
            )
        }
    }
}
</script>

<style scoped>
.symbol-groups {
    display: grid;
    grid-template-rows: max-content max-content 1fr;
    overflow: hidden;
}

select {
    margin: 0 15px 15px;
}

.chips-list {
    padding: 8px;

}

.chips-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.chips-icon {
    width: 18px;
    height: 18px;
}

.chips-cnt {
    border-radius: 2px;
    background: var(--System-Surface5);
    color: var(--System-OnSurfaceVariant);
    min-width: 16px;
    max-width: 34px;
    padding: 0px 2px;
    text-align: center;
}

.search-input {
    border-top: 1px solid var(--System-OutlineVariant);
    border-bottom: 1px solid var(--System-OutlineVariant);
}

.cat-title {
    display: flex;
    align-items: center;
    background: var(--market-watch-title);
    justify-content: space-between;
    padding: 8px 10px;
    color: var(--white-to-black);
    cursor: pointer;
    border-bottom: 1px solid var(--background-dark);
}

.cat-title i {
    font-size: 1.2em;
    margin: 0 5px 0 3px;
}

.row span {
    font-size: 12px;
}

.row-2 {
    display: flex;
    align-items: center;
}

.col {
    overflow: hidden;
}
</style>
